import CardsAccepted from './CardsAccepted';

export default CardsAccepted;
